import { render, staticRenderFns } from "./ClinicInvitesNotice.vue?vue&type=template&id=27c5ae80&scoped=true"
import script from "./ClinicInvitesNotice.vue?vue&type=script&lang=js"
export * from "./ClinicInvitesNotice.vue?vue&type=script&lang=js"
import style0 from "./ClinicInvitesNotice.vue?vue&type=style&index=0&id=27c5ae80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5ae80",
  null
  
)

export default component.exports